<template>
<v-card>
  <v-card-title class='subtitle-1 overline' >
    {{title}}
    <v-spacer/>
    <v-btn small icon @click="$emit('close')" >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <!-- <pre v-text="member" /> -->
  <request-status :request="req" @ok="$emit('saved');$emit('close')" />
  <v-card-text v-if="isArchived" >
    <v-checkbox v-model="confirm" label="Reactivate membership" />
  </v-card-text>
  <v-card-text v-else >
    Please confirm you would like to remove {{member.practitioner_name}} from
    <span v-if="space.title" v-text="space.title" />
    <v-checkbox v-model="confirm" label="I confirm" />
    <!-- <pre v-text="member" /> -->
  </v-card-text>
  <v-card-actions >
    <v-spacer/>
    <v-btn v-if="isArchived" @click="reactivate" :disabled="!confirm" color="primary" >
      Reactivate membership
    </v-btn>
    <v-btn
      v-else
      @click="remove" color="primary"
      :disabled="!confirm"
      :loading="req.loading" >Remove member</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: 'ToggleMember',
  props: {
    title: { type: String },
    member: { required: true }
    // space: { required: true }
  },
  data () {
    return {
      confirm: false,
      req: {
        resource: 'ag.team',
        extra: 'remove_from_space',
        method: 'post'
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['getSpaceById']),
    space () {
      if (this.member) {
        return this.getSpaceById(this.member.service)
      }
      return {}
    },
    isArchived () {
      return this.getObjectPath(this.member, 'is_archived', false)
    },
    practitionerId () {
      return this.getObjectPath(this.member, 'practitioner')
    }
  },
  methods: {
    validate () {
      this.req.data = {
        membership: this.member.id,
        space: this.space.id
      }
      this.req.method = 'post'
      this.$request('save', this.req)
    },
    reactivate () {
      this.req.data = {
        practitioner: this.practitionerId,
        space: this.space.id,
        role: this.member.role
      }
      this.req.extra = 'add_member_to_space'
      this.req.method = 'post'
      this.$request('save', this.req)
    },
    remove () {
      this.req.data = {
        membership: this.member.id,
        space: this.space.id
      }
      this.req.extra = 'remove_from_space'
      this.req.method = 'post'
      this.$request('save', this.req)
    }
  }
}
</script>
